export default "__VITE_ASSET__C2ST_S3u__"